import { Component } from '@angular/core'

@Component({
  selector: 'app-users-dashboard',
  template: `<div></div>`,
  standalone: true,
})
export class DashboardComponent {}
